import { useTranslation } from "react-i18next";
import { meetingTypeLabel } from "./MeetingMinutesTypePills";

export function MeetingMinutesTemplatePicker({
  templates = [],
  selectedId,
  onSelect,
}) {
  const { t } = useTranslation();

  return (
    <div className="grid gap-3 sm:grid-cols-2">
      <button
        type="button"
        onClick={() => onSelect(null)}
        className={`rounded-2xl border px-4 py-4 text-left transition ${
          !selectedId
            ? "border-[#1463C7] bg-[#EAF3FD] shadow-sm"
            : "border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50"
        }`}
      >
        <div className="text-sm font-semibold text-slate-900">
          {t("meeting_minutes.meeting.no_template")}
        </div>
        <p className="mt-1 text-xs text-slate-500">
          {t("meeting_minutes.templates.empty_start")}
        </p>
      </button>
      {templates.map((template) => {
        const selected = selectedId === template.id;
        const groups = template.groups || [];
        return (
          <button
            key={template.id}
            type="button"
            onClick={() => onSelect(template)}
            className={`rounded-2xl border px-4 py-4 text-left transition ${
              selected
                ? "border-[#1463C7] bg-[#EAF3FD] shadow-sm"
                : "border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50"
            }`}
          >
            <div className="text-sm font-semibold text-slate-900">{template.title}</div>
            <p className="mt-1 text-xs text-slate-500">
              {meetingTypeLabel(t, template.meeting_type)}
              {groups.length ? ` · ${groups.length} ${t("meeting_minutes.points")}` : ""}
            </p>
            {groups.length ? (
              <ul className="mt-2 space-y-1 text-xs text-slate-600">
                {groups.slice(0, 3).map((group) => (
                  <li key={group.id || group.title}>• {group.title}</li>
                ))}
                {groups.length > 3 ? <li>…</li> : null}
              </ul>
            ) : (
              <p className="mt-2 text-xs text-amber-700">
                {t("meeting_minutes.templates.no_points")}
              </p>
            )}
          </button>
        );
      })}
    </div>
  );
}
